import React from 'react';
import { BRAND, isMarketGB } from '../../constants/main';
import { CarGalleryStyledAC } from './AC/CarGalleryStyled.AC';
import { CarGalleryStyledAP } from './AP/CarGalleryStyled.AP';
import { CarGalleryStyledDS } from './DS/CarGalleryStyled.DS';
import { CarGalleryStyledOV } from './OV/CarGalleryStyled.OV';
import { CarGalleryStyledOV as CarGalleryStyledOV_GB } from './OV/GB/CarGalleryStyled.OV';
import { CarGalleryStyled } from './CarGalleryStyled';
import { SC } from '../../styles/theme';

export type CarGalleryProps = SC & {
    arrows: boolean;
    defaultArrows?: boolean;
    dots?: boolean;
    setSmallImage?: boolean;
    imageSet?: string;
    allowDefaultConfigurationImages?: boolean;
};

const CarGallery = (props: CarGalleryProps) => {
    if (BRAND === 'OV') return isMarketGB ? <CarGalleryStyledOV_GB {...props} /> : <CarGalleryStyledOV {...props} />;
    if (BRAND === 'AC') return <CarGalleryStyledAC {...props} />;
    if (BRAND === 'AP') return <CarGalleryStyledAP {...props} />;
    if (BRAND === 'DS') return <CarGalleryStyledDS {...props} />;
    return <CarGalleryStyled {...props} />;
};

export default CarGallery;
